
import Vue from "vue";
import { Action } from "vuex-class";
import { ActionMethod } from "vuex";
import { Component, Watch, Prop } from "vue-property-decorator";
import { Route } from "vue-router";
import firebase from "firebase";
import BaseTeamCard from "@/components/widgets/BaseTeamCard.vue";

import Chat from "@/components/core/Chat.vue";
import AccessibilitySkipLink from "@/components/common/AccessibilitySkipLink.vue";
import Dialog from "@/components/common/Dialog/index.vue";

import Header from "@/components/header/index.vue";
import Footer from "@/components/footer/index.vue";

import "reflect-metadata";
import { firebaseEnvironmentKey } from "@/utils/FirebaseKeys";
import { eventBus } from "@/modules/EventService";

@Component({
  components: {
    Footer,
    Header,
    BaseTeamCard,
    Chat,
    AccessibilitySkipLink,
    Dialog,
  },
})
export default class App extends Vue {
  @Action getTokenChat!: ActionMethod;
  @Action setIsShowPortability!: ActionMethod;
  @Action setPromoPlan!: ActionMethod;
  @Action setIsShowSimDelivery!: ActionMethod;
  @Action getVertexParams!: ActionMethod;
  @Action getIdOrigin!: ActionMethod;
  @Action setFlowCollaboratorActive!: ActionMethod;
  @Action setSkeeloCompositionId!: ActionMethod;
  @Action setLockCoupons!: ActionMethod;
  @Action actionBlackFriday!: ActionMethod;
  @Action actionPromotionLabel!: ActionMethod;
  @Prop({ default: "" }) readonly uriChat!: string;
  showAlertMessage = false;
  isWhatsAppEnabled = false;
  isChatEnabled = false;
  showFooterFlag = false;
  customParentClass = "";
  hideFooterInRoutes: string[] = [
    "ForgotPassword",
    "Register",
    "Login",
    "SetPassword",
    "ResetPassword",
  ];

  @Watch("$route", {
    immediate: true,
    deep: true,
  })
  showFooter(newVal: Route): void {
    if (!newVal.name) {
      this.showFooterFlag = false;
      return;
    }
    this.showFooterFlag = !this.hideFooterInRoutes.includes(newVal.name);
    this.getParentClassName();
  }

  async getParentClassName(): Promise<void> {
    let path = this.$route.path || "";
    if (!path.length) {
      return;
    }
    path = path.replaceAll("/", " ").trim().split(" ").join("-");
    this.customParentClass = path.length ? path : "dashboard";
  }

  keyListener(e: KeyboardEvent) {
    const activeElement = document.activeElement;
    const inputs = ["input", "select", "textarea"];
    if (
      e.shiftKey &&
      activeElement &&
      inputs.indexOf(activeElement.tagName.toLowerCase()) === -1 &&
      (e.key.toLowerCase() === "f" ||
        e.key.toLowerCase() === "t" ||
        e.key.toLowerCase() === "c" ||
        e.key.toLowerCase() === "m")
    ) {
      e.preventDefault();
      switch (e.key.toLowerCase()) {
        case "f":
          setTimeout(() => {
            document.getElementById("footer")?.scrollIntoView();
            document.getElementById("footer")?.focus();
          }, 100);
          break;
        case "t":
          setTimeout(() => {
            document.getElementById("header")?.scrollIntoView();
            document.getElementById("header")?.focus();
          }, 100);
          document.getElementById("header-logo")?.focus();
          break;
        case "c":
          setTimeout(() => {
            document.getElementById("body")?.scrollIntoView();
            document.getElementById("body")?.focus();
          }, 100);
          break;
        case "m":
          setTimeout(() => {
            document.getElementById("main")?.scrollIntoView();
            document.getElementById("main")?.focus();
          }, 100);
          break;
      }
    }
  }

  mounted() {
    window.addEventListener("keypress", this.keyListener);
    eventBus.$on("authError", (isAuthError: boolean) => {
      if (isAuthError) {
        this.showAlertMessage = true;
      }
    });
  }

  beforeDestroy() {
    window.removeEventListener("keypress", this.keyListener);
  }

  hideAlertMessage() {
    this.showAlertMessage = false;
    this.$router.push({
      name: "Home",
    });
  }

  async created() {
    const firebaseConfig = {
      apiKey: "AIzaSyDR7yGghTFp-16FQX0I4xILNP_FbB6IpDA",
      authDomain: "claroflex-prod.firebaseapp.com",
      databaseURL: "https://claroflex-prod.firebaseio.com",
      projectId: "claroflex-prod",
      storageBucket: "claroflex-prod.appspot.com",
      messagingSenderId: "244910085520",
      appId: "1:244910085520:web:ce4708a57168e878ba4f15",
      measurementId: "G-XCN7NYN1GL",
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
      firebase.analytics();
    }

    const remoteConfig = firebase.remoteConfig();
    remoteConfig.settings.minimumFetchIntervalMillis = 10000;
    await remoteConfig.fetchAndActivate();
    this.isWhatsAppEnabled = remoteConfig.getBoolean("QA_show_whatsapp");
    const showPortabilityFirebaseKey = await firebaseEnvironmentKey(
      "show_portability"
    );
    const showPortability = remoteConfig.getBoolean(showPortabilityFirebaseKey);
    const tikTokFirebaseKey = await firebaseEnvironmentKey("tiktok");
    const promoPlanFirebaseKey = await firebaseEnvironmentKey("promo_plan");
    const skeeloCompositionIdKey = await firebaseEnvironmentKey(
      "skeelo_composition_id_portal"
    );

    if (showPortability) {
      this.$store.dispatch("setIsShowPortability", showPortability);
    }

    await this.getIdOrigin();
    await this.setFlowCollaboratorActive();

    this.isChatEnabled =
      remoteConfig.getBoolean("QA_show_chat") &&
      this.$router.currentRoute.name !== "NcndLink";
    const tiktok = remoteConfig.getString(tikTokFirebaseKey).split("|");
    await this.$store.dispatch("setTikTok", tiktok);
    const promoPlan = remoteConfig.getString(promoPlanFirebaseKey);
    await this.$store.dispatch("setPromoPlan", promoPlan);
    await this.setIsShowSimDelivery();
    const skeeloCompositionId = remoteConfig
      .getString(skeeloCompositionIdKey)
      .split("|");
    await this.setSkeeloCompositionId(skeeloCompositionId);
    this.getVertexParams();
    const lockCouponsKey = await firebaseEnvironmentKey(
      "lock_coupons_plans_portal"
    );
    const lockCouponsPlansPortal = remoteConfig
      .getString(lockCouponsKey)
      .split("|");
    this.setLockCoupons(lockCouponsPlansPortal);
    this.actionBlackFriday();
    await this.actionPromotionLabel();
  }
}
